export default "__VITE_ASSET__DQyiQOfW__"